module.exports = {"title":"Share Your Event","content":"Buy your tickets for"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Share/locales/fr.json
// module id = 1294
// module chunks = 0